import AntSynSymbol from "./AntSynSymbol";
import { VocaMeaningLine } from "./VocaCardFront";
import "./VocaCardBack.css";

// 이 길이부터는 폰의 좁은 단어 칸에 한 줄로 안 들어가 글자를 줄인다.
const LONG_WORD_LENGTH = 10;

// 짝 표현(지인에듀 단어 3판 refined.collocations, 2026-11). 예전 출제분에는 없다
const collocationListOf = (page) =>
  (page.refined?.collocations || []).filter((one) => one && one.english);

// 예문 안의 짝 표현을 굵게. 대소문자만 다르게 쓰인 것도 찾는다
const HighlightedPhrase = ({ sentence, phrase }) => {
  const start = phrase ? sentence.toLowerCase().indexOf(phrase.toLowerCase()) : -1;
  if (start < 0) return sentence;
  return (
    <>
      {sentence.slice(0, start)}
      <strong>{sentence.slice(start, start + phrase.length)}</strong>
      {sentence.slice(start + phrase.length)}
    </>
  );
};

const VocaCardBack = ({ currentPage }) => {
  return (
    <div className="voca-card-back">
      <div className="voca-card-back__row">
        <div className="voca-card-back__word-cell">
          <div
            className={`voca-card-back__word${currentPage.word.length >= LONG_WORD_LENGTH ? " voca-card-back__word--long" : ""}`}
            lang="en"
          >
            {currentPage.word}
          </div>
          <div className="voca-card-back__pron">
            {currentPage.pron}
          </div>
          {currentPage.syn && (
            <div className="voca-card-back__relation">
              <AntSynSymbol type="syn" />
              <div>
                {currentPage.syn.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          )}
          {currentPage.ant && (
            <div className="voca-card-back__relation">
              <AntSynSymbol type="ant" />
              <div>
                {currentPage.ant.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="voca-card-back__meaning-cell">
          {currentPage.kor.split("\n").map((line, index) => (
            <VocaMeaningLine key={index} line={line} />
          ))}
          {collocationListOf(currentPage).length > 0 && (
            <div className="voca-card-back__collocation-list">
              {collocationListOf(currentPage).map((one, index) => (
                <div key={index} className="voca-card-back__collocation">
                  <b lang="en">{one.english}</b>
                  <span>{one.korean}</span>
                </div>
              ))}
            </div>
          )}
          {currentPage.eng && (
            <div className="voca-card-back__english" lang="en">
              {currentPage.eng.split("\n").map((line, index) => (
                <VocaMeaningLine key={index} line={line} />
              ))}
            </div>
          )}
        </div>
      </div>
      {(currentPage.example || collocationListOf(currentPage).some((one) => one.example?.english)) && (
        <div className="voca-card-back__example">
          {(currentPage.example ? currentPage.example_list : []).map((line, exampleIndex) => (
            <div key={exampleIndex} className="voca-card-back__sentence">
              <div lang="en">
                {line
                  .split(/(\{.*?\})/g)
                  .map((part, index) =>
                    part.startsWith("{") && part.endsWith("}") ? (
                      <strong key={index}>{part.slice(1, -1)}</strong>
                    ) : (
                      part
                    )
                  )}
              </div>
              <div className="voca-card-back__translation">{currentPage.example_translation_list[exampleIndex]}</div>
            </div>
          ))}
          {collocationListOf(currentPage)
            .filter((one) => one.example?.english)
            .map((one, index) => (
              <div key={`collocation-${index}`} className="voca-card-back__sentence">
                <div lang="en">
                  <HighlightedPhrase sentence={one.example.english} phrase={one.english} />
                </div>
                <div className="voca-card-back__translation">{one.example.korean}</div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default VocaCardBack;
